import { render } from "./resignation.vue?vue&type=template&id=1d9b3a8f"
import script from "./resignation.vue?vue&type=script&lang=js"
export * from "./resignation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__